"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyTmpVpnError = void 0;
class MyTmpVpnError extends Error {
    constructor(msg) {
        super(msg); // 'Error' breaks prototype chain here
        // See: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    }
}
exports.MyTmpVpnError = MyTmpVpnError;
